import { useMutation } from 'react-query'
import { endpoints } from '@app/api/config'
import { ApiErrorResponse } from 'BackendApi'
import { apiAuthClient } from '@app/services/apiAuthClient'

type PostChangePlanParams = {
  creditCardToken?: string
  planId: string
  trial: boolean
  trialDays?: number
}

const postChangePlan = async ({
  creditCardToken,
  planId,
  trial,
  trialDays,
}: PostChangePlanParams) => {
  const apiResponse = await apiAuthClient.post(endpoints.changePlan, {
    creditCardToken,
    planId,
    trial,
    trialDays,
  })

  return apiResponse.data
}

export const useChangePlan = () =>
  useMutation<unknown, ApiErrorResponse, PostChangePlanParams>(postChangePlan)
